const captureImageFrame = (image: HTMLImageElement): string | null => {
    if (!image.complete || image.naturalWidth === 0) {
        return null;
    }

    const dpr = window.devicePixelRatio || 1;
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(image.clientWidth * dpr);
    canvas.height = Math.round(image.clientHeight * dpr);

    const ctx = canvas.getContext('2d');
    if (!ctx) {
        return null;
    }

    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

    return canvas.toDataURL('image/png');
};

export { captureImageFrame };
